import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const PiggyBankIllustration = ({ width = 240, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 46">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFBF00"
          d="M30.194 3.89c0 2.15-1.744 3.89-3.89 3.89-2.151 0-3.89-1.744-3.89-3.89 0-2.151 1.745-3.89 3.89-3.89 2.152 0 3.89 1.744 3.89 3.89M22.899 10.448c0 2.151-1.744 3.89-3.89 3.89-2.151 0-3.889-1.744-3.889-3.89 0-2.15 1.744-3.89 3.889-3.89 2.152-.006 3.89 1.74 3.89 3.89"
        />
        <path
          fill="#231F20"
          d="M26.304 0c2.151 0 3.89 1.744 3.89 3.89 0 2.151-1.744 3.89-3.89 3.89V0zM19.01 6.553c2.15 0 3.89 1.744 3.89 3.89s-1.745 3.89-3.89 3.89v-7.78z"
          opacity=".1"
        />
        <path
          fill="#ED585D"
          d="M22.862 19.548c-1.358-.387-2.816-.598-4.334-.598-1.518 0-2.976.211-4.335.598v-1.244c1.369-.36 2.825-.555 4.335-.555 1.509 0 2.965.195 4.334.555v1.244zM8.95 25.841c-.92 0-1.667-.748-1.667-1.668 0-.919.748-1.667 1.667-1.667.92 0 1.668.748 1.668 1.667 0 .92-.748 1.668-1.668 1.668zm25.682 2.875c-.637-6.909-7.228-12.39-15.357-12.715-.258-.012-.51-.03-.772-.03-.59 0-1.496.067-2.012.116-3.433-3.108-10.158-2.385-10.158-2.385l1.109 1.11c1.55 1.551 1.747 2.783 1.864 3.611-2.784 1.655-4.948 4.065-6.076 6.781H0v9.245h3.23c1.129 2.722 3.238 5.09 6.022 6.75v4.795h4.623v-2.888c1.747.454 3.55.644 5.394.564.767-.037 1.533-.11 2.312-.245V46h4.623v-3.992c4.892-2.268 8.037-6.449 8.429-11.164.589.32 1.343.534 2.36.534v-1.552c-1.17 0-1.948-.374-2.36-1.11z"
        />
        <path
          fill="#231F20"
          d="M34.633 28.717c-.638-6.91-7.229-12.39-15.357-12.715-.258-.013-.509-.031-.773-.031 0 0 .42.6.955 1.803 1.178.063 2.32.245 3.404.53v1.245c-.925-.264-1.896-.445-2.9-.535.85 2.296 1.753 5.894 1.753 10.8 0 9.246-3.212 13.869-3.212 13.869.257 0 .515-.007.773-.02.765-.035 1.532-.11 2.31-.244v2.575h4.623v-3.991c4.893-2.268 8.038-6.45 8.43-11.164.59.318 1.343.533 2.36.533v-1.545c-1.177 0-1.955-.374-2.366-1.11"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
